export class OrderedTaskSteps {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get task() {
        return this.parent;
    }
    get completedSteps() {
        return this.task.steps.filter(step => step.stepProgress.isStepCompleted);
    }
    get remainingSteps() {
        return this.task.steps.filter(step => !step.stepProgress.isStepCompleted);
    }
}
